import { getCookieConsentValue } from "react-cookie-consent";

/**
 * Whether the apps ask before tracking.
 *
 * Neither does. The UK app has never rendered a cookie banner, and Bits has
 * decided the US does not require one either (Faisal, 9 Sep 2026), so the ad
 * pixels load and report for every visitor.
 *
 * One switch rather than the same condition copied into each wrapper — but
 * note that flipping it to `true` is not on its own enough to reinstate
 * consent: `UserCookieConsent` no longer renders a banner, so there would be
 * nothing for a visitor to accept and every pixel would simply go quiet. The
 * banner markup is in this file's history if it is ever needed again.
 *
 * Snapchat, Twitter and Facebook are NOT covered by this. They read the
 * consent cookie directly, and because no banner sets it they are all
 * effectively off today — see the note in `UserCookieConsent`.
 */
export const TRACKING_REQUIRES_CONSENT = false;

/**
 * @param grantedThisSession a grant recorded in memory by the pixel wrapper,
 *   which is how an acceptance reaches it before the cookie can be read back.
 */
export const isTrackingAllowed = (grantedThisSession = false): boolean =>
  !TRACKING_REQUIRES_CONSENT || grantedThisSession || getCookieConsentValue() === "true";
